import { getProductImageThumbnail } from "@/api/ProductImage";
const imageSrc = {
    props: {
        maxRetry: {
            type: Number,
            default: 10,
        },
    },
    data() {
        return {
            imageSrc: null,
            imageIndex: 0,
        };
    },
    methods: {
        initializeImageSrc(cprcode, original) {
            this.imageSrc = getProductImageThumbnail(cprcode, original);
            this.imageIndex = 0;
        },
        retryImageSrc(cprcode, original) {
            if (this.imageIndex <= this.maxRetry) {
                this.imageSrc =
                    getProductImageThumbnail(cprcode, original) +
                    "-" +
                    this.imageIndex;
                this.imageIndex++;
            }
        },
    },
};

export default imageSrc;
